// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiURL: "developmentApi",

  firebaseConfig: {
    apiKey: "AIzaSyAN0x05UTMNv4hsPDHM4BP6Lv-DqrOlR2E",
    authDomain: "stripedemo-hara.firebaseapp.com",
    databaseURL: "https://stripedemo-hara.firebaseio.com",
    projectId: "stripedemo-hara",
    storageBucket: "stripedemo-hara.appspot.com",
    messagingSenderId: "702284395428",
    appId: "1:702284395428:web:afc144a2c966d4c4228731",
    measurementId: "G-5LNL6GG3HF"
  }
};
